module.exports = __webpack_public_path__ + "static/media/vnda5.139923a7.png";